
export enum CommodityClaimTypeCd {
	CREDIT = 'Credit',
	DAMAGE = 'Damage',
	FREIGHT = 'Freight',
	MISCELLANEOUS = 'Miscellaneous',
	SHORTAGE = 'Shortage'}

